import React from 'react';
import { MdRefresh } from 'react-icons/md';
import { Button } from 'react-covideo-common';
import { EmptySearchWrapper, EmptySearchText } from '../../styles';
import { UIKitCard } from './UIKitCard';
import { Flex } from 'lib/components/styles/layout';
import { IUIKitFormData } from '../../types';
import { FetchNextPageOptions, InfiniteQueryObserverResult } from 'react-query';
import {
  IUIKitsQueryParams,
  IUIKitsResponse,
} from 'lib/api/superadmin/uikits/useQueryUIKits';
import { LoadingIndicator } from 'lib/components';

interface IUIKitListProps {
  uiKits?: IUIKitFormData[];
  isFetching: boolean;
  isLoading: boolean;
  isDuplicating: boolean;
  handleUpdateUIKit: (id: number | undefined) => void;
  fetchNextPage: (
    options?: FetchNextPageOptions
  ) => Promise<InfiniteQueryObserverResult<IUIKitsResponse, unknown>>;
  totalCount: number;
  pageTotal: number;
  params: IUIKitsQueryParams;
  scrollToTop: () => void;
  remove: <X = any>(index: number) => X | undefined;
  unshift: <X = any>(value: X) => number;
}

export const UIKitList = ({
  uiKits,
  isFetching,
  isLoading,
  isDuplicating,
  handleUpdateUIKit,
  fetchNextPage,
  totalCount,
  pageTotal,
  params,
  scrollToTop,
  remove,
  unshift,
}: IUIKitListProps) => {
  const disabled = isFetching || isDuplicating || isLoading;
  return (
    <Flex gap='24px' style={{ position: 'relative' }} alignItems='center'>
      {isLoading ? (
        <LoadingIndicator isLoading={isLoading} height={120} />
      ) : !uiKits || uiKits?.length === 0 ? (
        <EmptySearchWrapper minHeight='0px'>
          <EmptySearchText fontSize='16px' maxWidth='239px'>
            Sorry we couldn’t find what you were looking for. Please try again.
          </EmptySearchText>
        </EmptySearchWrapper>
      ) : (
        uiKits.map(uiKit => (
          <UIKitCard
            key={uiKit.id}
            uiKit={uiKit}
            handleUpdateUIKit={handleUpdateUIKit}
            params={params}
            scrollToTop={scrollToTop}
            disabled={disabled}
            remove={remove}
            unshift={unshift}
          />
        ))
      )}

      {pageTotal < totalCount && (
        <Button
          icon={<MdRefresh />}
          loading={isFetching || isDuplicating}
          variant='secondary'
          text='Load More'
          size='small'
          onClick={() => fetchNextPage()}
          style={{ width: '110px' }}
        />
      )}
    </Flex>
  );
};
